module.exports = __webpack_public_path__ + "img/petstairs33.3164a96f.jpg";